import urls from 'urls';
import {UPDATE_EVENT_DETAILS} from '~/CreateFabricGreetingCard/reducers/details/constants';
import {RECIPIENT_EXITING_PAGE} from '~/CreateFabricGreetingCard/reducers/recipientsMessage';
import {qsArrayTransform} from '~/CreateGreetingCard/utils/navigation';

export const getLastPathComponent = (path) => {
  const components = path.split('/');
  return components[components.length - 1];
};

const getGalleryUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);

  const category = urlParams.get('c');
  const page = urlParams.get('page');
  const filter = qsArrayTransform('filter');

  return category && page ? `/gallery/category/${category}/${page}?${filter}` : '/';
};

export const navigateToPrevious = (store) => {
  const urlParams = new URLSearchParams(window.location.search);
  const previous = urlParams.get('previous');
  let destination = '/';
  const greetingCardId = store.getState()?.greetingCardDetails?.greetingCardId;
  switch (previous) {
    case 'home':
      destination = '/';
      break;
    case 'event_dashboard':
      // biome-ignore lint/style/useNamingConvention: camel case
      if (greetingCardId) destination = urls.get('event_dashboard', {event_id: greetingCardId});
      break;
    case 'gallery':
      destination = getGalleryUrl();
      break;
    default:
      break;
  }
  window.location.href = destination;
};

export const backToGallery = () => {
  window.location.href = getGalleryUrl();
};

export const setInEditMode = async (store) => {
  store.dispatch({
    type: UPDATE_EVENT_DETAILS,
    payload: {inEditMode: true},
  });
  return true; // allow navigation
};

export const setRecipientExitPage = async (store) => {
  store.dispatch({
    type: RECIPIENT_EXITING_PAGE,
    payload: {},
  });
  return true; // allow navigation
};
